import type { Font } from '../../../../../hooks';

export const systemFonts: Font[] = [
  {
    family: 'Arial',
    fallbackFonts: 'sans-serif',
    source: 'System fonts',
  },
  {
    family: 'Verdana',
    fallbackFonts: 'sans-serif',
    source: 'System fonts',
  },
  {
    family: 'Tahoma',
    fallbackFonts: 'sans-serif',
    source: 'System fonts',
  },
  {
    family: 'Trebuchet MS',
    fallbackFonts: 'sans-serif',
    source: 'System fonts',
  },
  {
    family: 'Times New Roman',
    fallbackFonts: 'serif',
    source: 'System fonts',
  },
  {
    family: 'Georgia',
    fallbackFonts: 'serif',
    source: 'System fonts',
  },
  {
    family: 'Garamond',
    fallbackFonts: 'serif',
    source: 'System fonts',
  },
  {
    family: 'Courier New',
    fallbackFonts: 'Courier, monospace',
    source: 'System fonts',
  },
  {
    family: 'Brush Script MT',
    fallbackFonts: 'cursive',
    source: 'System fonts',
  },
];
